
const setUser = (state, user) => {
  // eslint-disable-next-line
  state.user = user;
};

export default {
  setUser,
};
